// BACI CUSTOM START: collection scroll restoration
(function () {
  var STORAGE_PREFIX = "baci-collection-restore:";
  var DEBUG_KEY = "baci-collection-restore-debug";
  var STATE_TTL = 30 * 60 * 1000;
  var MAX_FETCHED_PAGES = 20;
  var MAX_READY_ATTEMPTS = 80;
  var MAX_SCROLL_ATTEMPTS = 60;
  var RETRY_DELAY = 50;
  var SCROLL_TOLERANCE = 3;
  var SCROLL_PADDING = 16;
  var DEBUG_LIMIT = 40;

  if (!window || !document) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var storage;
  try {
    storage = window.sessionStorage;
  } catch (error) {
    return;
  }

  if (!storage) return;

  var restoreStarted = false;

  function writeDebug(step, details) {
    var log;

    try {
      log = JSON.parse(storage.getItem(DEBUG_KEY)) || [];
      log.push({
        step: step,
        details: details || {},
        page: window.location.pathname + window.location.search,
        timestamp: Date.now()
      });

      storage.setItem(DEBUG_KEY, JSON.stringify(log.slice(DEBUG_LIMIT * -1)));
    } catch (error) {
      // Debug logging should never affect storefront behavior.
    }
  }

  function getScrollX() {
    return window.pageXOffset || document.documentElement.scrollLeft || (document.body && document.body.scrollLeft) || 0;
  }

  function getScrollY() {
    return window.pageYOffset || document.documentElement.scrollTop || (document.body && document.body.scrollTop) || 0;
  }

  function getPageHeight() {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(
      body ? body.scrollHeight : 0,
      html ? html.scrollHeight : 0
    );
  }

  function getCurrentPageKey() {
    return window.location.pathname + window.location.search;
  }

  function getStorageKey() {
    return STORAGE_PREFIX + getCurrentPageKey();
  }

  function isBackForwardNavigation(event) {
    var navigationEntries;

    if (event && event.persisted) return true;

    try {
      if (window.performance && typeof window.performance.getEntriesByType === "function") {
        navigationEntries = window.performance.getEntriesByType("navigation");
        if (navigationEntries && navigationEntries[0]) {
          return navigationEntries[0].type === "back_forward";
        }
      }

      if (window.performance && window.performance.navigation) {
        return window.performance.navigation.type === 2;
      }
    } catch (error) {
      return false;
    }

    return false;
  }

  function parseUrl(value) {
    if (!value) return null;

    try {
      return new window.URL(value, window.location.href);
    } catch (error) {
      return null;
    }
  }

  function getProductHandleFromUrl(value) {
    var url = parseUrl(value);
    if (!url) return "";

    var parts = url.pathname.split("/");
    for (var index = 0; index < parts.length; index += 1) {
      if (parts[index] === "products" && parts[index + 1]) {
        return decodeURIComponent(parts[index + 1]).replace(/\/$/, "");
      }
    }

    return "";
  }

  function getCollectionRoot() {
    return document.querySelector('[data-section-type="collection"]');
  }

  function getGrid() {
    return document.querySelector(".collection__infinite-container");
  }

  function getTrigger() {
    return document.querySelector(".collection__infinite-trigger");
  }

  function getNextPageUrl() {
    var trigger = getTrigger();
    var link = trigger && trigger.querySelector ? trigger.querySelector("a[href]") : null;

    return link ? link.getAttribute("href") : "";
  }

  function getCards() {
    var grid = getGrid();
    if (!grid || !grid.querySelectorAll) return [];

    return Array.prototype.slice.call(grid.querySelectorAll("[data-baci-product-card], .product-item"));
  }

  function isCollectionPage() {
    return Boolean(getCollectionRoot() && getGrid());
  }

  function isStaleState(state) {
    return !state.timestamp || Date.now() - state.timestamp > STATE_TTL;
  }

  function removeState(reason) {
    try {
      storage.removeItem(getStorageKey());
      writeDebug("state:removed", { reason: reason || "unknown" });
    } catch (error) {
      // Storage can be blocked. Restoration already finished or failed safely.
    }
  }

  function readState() {
    var state;

    try {
      state = JSON.parse(storage.getItem(getStorageKey()));
    } catch (error) {
      removeState("parse-error");
      return null;
    }

    if (!state) return null;

    if (state.collectionKey !== getCurrentPageKey()) {
      removeState("collection-key-mismatch");
      return null;
    }

    if (isStaleState(state)) {
      removeState("stale");
      return null;
    }

    return state;
  }

  function getCardHandle(card) {
    if (!card || !card.getAttribute) return "";

    var handle = card.getAttribute("data-baci-product-handle");
    if (handle) return handle;

    handle = getProductHandleFromUrl(card.getAttribute("data-baci-product-url"));
    if (handle) return handle;

    var link = card.querySelector ? card.querySelector('a[href*="/products/"]') || card.querySelector("a[href]") : null;
    return link ? getProductHandleFromUrl(link.getAttribute("href")) : "";
  }

  function findTargetCard(state) {
    var cards = getCards();
    var targetHandle = state.productHandle || getProductHandleFromUrl(state.productUrl);
    var index;

    if (targetHandle) {
      for (index = 0; index < cards.length; index += 1) {
        if (getCardHandle(cards[index]) === targetHandle) {
          return cards[index];
        }
      }
    }

    if (
      typeof state.cardIndex === "number" &&
      state.cardIndex >= 0 &&
      cards.length > state.cardIndex &&
      (!state.loadedCount || cards.length >= state.loadedCount)
    ) {
      return cards[state.cardIndex];
    }

    return null;
  }

  function shouldFetchMore(state, fetchedPages) {
    if (fetchedPages >= MAX_FETCHED_PAGES) return false;
    if (findTargetCard(state)) return false;

    return Boolean(getNextPageUrl());
  }

  function dispatchCollectionUpdated() {
    var event;

    if (typeof window.CustomEvent === "function") {
      event = new window.CustomEvent("collection:updated", { bubbles: true });
    } else {
      event = document.createEvent("CustomEvent");
      event.initCustomEvent("collection:updated", true, false, null);
    }

    document.dispatchEvent(event);
  }

  function appendFetchedProducts(responseText) {
    var parser = new window.DOMParser();
    var nextDocument = parser.parseFromString(responseText, "text/html");
    var currentGrid = getGrid();
    var currentTrigger = getTrigger();
    var nextGrid = nextDocument.querySelector(".collection__infinite-container");
    var nextTrigger = nextDocument.querySelector(".collection__infinite-trigger");
    var nextCards = nextGrid ? nextGrid.querySelectorAll("[data-baci-product-card], .product-item") : [];
    var index;

    if (!currentGrid || !nextCards.length) {
      writeDebug("fetch:empty-page", { hasGrid: Boolean(currentGrid), nextCards: nextCards.length });
      return false;
    }

    for (index = 0; index < nextCards.length; index += 1) {
      currentGrid.appendChild(nextCards[index].cloneNode(true));
    }

    if (currentTrigger && nextTrigger) {
      currentTrigger.innerHTML = nextTrigger.innerHTML;
    } else if (currentTrigger) {
      currentTrigger.innerHTML = "";
    }

    writeDebug("fetch:appended", { appended: nextCards.length, totalCards: getCards().length, nextPageUrl: getNextPageUrl() });
    dispatchCollectionUpdated();
    return true;
  }

  function fetchNextPage(callback) {
    var nextPageUrl = getNextPageUrl();

    if (!nextPageUrl || !window.fetch || !window.DOMParser) {
      writeDebug("fetch:unavailable", { nextPageUrl: nextPageUrl });
      callback(false);
      return;
    }

    writeDebug("fetch:start", { nextPageUrl: nextPageUrl });

    window.fetch(nextPageUrl, { credentials: "same-origin" })
      .then(function (response) {
        if (!response.ok) throw new Error("Unable to fetch next collection page");
        return response.text();
      })
      .then(function (responseText) {
        callback(appendFetchedProducts(responseText));
      })
      .catch(function (error) {
        writeDebug("fetch:error", { message: error && error.message ? error.message : "unknown" });
        callback(false);
      });
  }

  function loadUntilTargetExists(state, fetchedPages, callback) {
    var targetCard = findTargetCard(state);

    if (targetCard || !shouldFetchMore(state, fetchedPages)) {
      writeDebug("load:done", {
        foundTarget: Boolean(targetCard),
        fetchedPages: fetchedPages,
        totalCards: getCards().length,
        nextPageUrl: getNextPageUrl()
      });
      callback(targetCard);
      return;
    }

    fetchNextPage(function (loaded) {
      if (!loaded) {
        callback(findTargetCard(state));
        return;
      }

      loadUntilTargetExists(state, fetchedPages + 1, callback);
    });
  }

  function getStickyHeaderOffset() {
    var header = document.querySelector("[data-header], .header, .site-header, .header__inner");
    var style;
    var rect;

    if (!header || !header.getBoundingClientRect || !window.getComputedStyle) return 0;

    style = window.getComputedStyle(header);
    if (style.position !== "fixed" && style.position !== "sticky") return 0;

    rect = header.getBoundingClientRect();
    if (rect.bottom <= 0 || rect.top > SCROLL_PADDING) return 0;

    return Math.min(180, Math.max(0, rect.bottom)) + SCROLL_PADDING;
  }

  function scrollToPosition(x, y) {
    try {
      window.scrollTo({ left: x, top: y, behavior: "auto" });
    } catch (error) {
      window.scrollTo(x, y);
    }
  }

  function isCardRestored(card) {
    var rect;
    var headerOffset;

    if (!card || !card.getBoundingClientRect) return false;

    rect = card.getBoundingClientRect();
    headerOffset = getStickyHeaderOffset();

    return rect.top >= headerOffset - SCROLL_TOLERANCE && rect.top <= window.innerHeight * 0.65;
  }

  function scrollToCard(card, state, attempt, stableAttempts) {
    var rect;
    var targetY;

    if (!card || !card.getBoundingClientRect) {
      writeDebug("scroll:missing-card");
      restoreFallbackScroll(state, 0, 0);
      return;
    }

    rect = card.getBoundingClientRect();
    targetY = Math.max(0, Math.round(getScrollY() + rect.top - getStickyHeaderOffset()));
    scrollToPosition(state.scrollX || 0, targetY);

    if (Math.abs(getScrollY() - targetY) <= SCROLL_TOLERANCE || isCardRestored(card)) {
      stableAttempts += 1;
    } else {
      stableAttempts = 0;
    }

    writeDebug("scroll:attempt", {
      attempt: attempt,
      stableAttempts: stableAttempts,
      targetY: targetY,
      currentY: getScrollY(),
      cardTop: rect.top
    });

    if (stableAttempts >= 3) {
      removeState("card-restored");
      return;
    }

    if (attempt >= MAX_SCROLL_ATTEMPTS) {
      writeDebug("scroll:gave-up", { currentY: getScrollY(), targetY: targetY });
      return;
    }

    window.setTimeout(function () {
      scrollToCard(card, state, attempt + 1, stableAttempts);
    }, RETRY_DELAY);
  }

  function restoreFallbackScroll(state, attempt, stableAttempts) {
    var targetY = Math.max(0, Math.round(Number(state.scrollY) || 0));
    var maxScrollableY = Math.max(0, getPageHeight() - window.innerHeight);

    if (maxScrollableY >= targetY) {
      scrollToPosition(state.scrollX || 0, targetY);

      if (Math.abs(getScrollY() - targetY) <= SCROLL_TOLERANCE) {
        stableAttempts += 1;
      } else {
        stableAttempts = 0;
      }

      if (stableAttempts >= 3) {
        removeState("fallback-restored");
        return;
      }
    }

    if (attempt >= MAX_SCROLL_ATTEMPTS) {
      writeDebug("fallback:gave-up", { maxScrollableY: maxScrollableY, targetY: targetY, currentY: getScrollY() });
      return;
    }

    window.setTimeout(function () {
      restoreFallbackScroll(state, attempt + 1, stableAttempts);
    }, RETRY_DELAY);
  }

  function waitForCollectionReady(callback, attempt) {
    if (isCollectionPage()) {
      callback();
      return;
    }

    if (attempt >= MAX_READY_ATTEMPTS) {
      writeDebug("ready:gave-up");
      return;
    }

    window.setTimeout(function () {
      waitForCollectionReady(callback, attempt + 1);
    }, RETRY_DELAY);
  }

  function restoreCollectionState(event) {
    var state;

    if (restoreStarted || window.location.hash) return;
    if (!isBackForwardNavigation(event)) return;

    state = readState();
    if (!state) return;

    restoreStarted = true;
    writeDebug("restore:start", {
      productHandle: state.productHandle,
      cardIndex: state.cardIndex,
      loadedCount: state.loadedCount,
      scrollY: state.scrollY
    });

    waitForCollectionReady(function () {
      loadUntilTargetExists(state, 0, function (targetCard) {
        if (targetCard) {
          scrollToCard(targetCard, state, 0, 0);
        } else {
          writeDebug("restore:fallback", { totalCards: getCards().length });
          restoreFallbackScroll(state, 0, 0);
        }
      });
    }, 0);
  }

  function saveCollectionState(event) {
    var link = event.target && event.target.closest ? event.target.closest("a[href]") : null;
    var grid = getGrid();
    var card;
    var cards;
    var productUrl;
    var productHandle;
    var state;

    if (!link || !grid || !grid.contains(link)) return;

    card = link.closest ? link.closest("[data-baci-product-card], .product-item") : null;
    if (!card) return;

    productUrl = card.getAttribute("data-baci-product-url") || link.getAttribute("href");
    productHandle = card.getAttribute("data-baci-product-handle") || getProductHandleFromUrl(productUrl);

    if (!productHandle && productUrl.indexOf("/products/") === -1) return;

    cards = getCards();
    state = {
      version: 1,
      collectionKey: getCurrentPageKey(),
      productUrl: productUrl,
      productHandle: productHandle,
      cardIndex: cards.indexOf(card),
      loadedCount: cards.length,
      nextPageUrl: getNextPageUrl(),
      scrollX: getScrollX(),
      scrollY: getScrollY(),
      timestamp: Date.now()
    };

    try {
      storage.setItem(getStorageKey(), JSON.stringify(state));
      writeDebug("state:saved", state);
    } catch (error) {
      writeDebug("state:save-error", { message: error && error.message ? error.message : "unknown" });
    }
  }

  try {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  } catch (error) {
    // Some embedded browsers expose history but reject assignment.
  }

  document.addEventListener("click", saveCollectionState, true);
  window.addEventListener("pageshow", restoreCollectionState);
  window.addEventListener("load", restoreCollectionState);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", restoreCollectionState);
  } else {
    restoreCollectionState();
  }
})();
// BACI CUSTOM END: collection scroll restoration
